import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { ReportsService } from '../../reports.service'
import {
  GetAdminMarketPricing,
  AdminUpdateMarketPricing,
  GetMarketPricing,
  GetMarketPricingThresholds,
  MarketPricingStatusChanged,
  ResetMarketPricing,
  UpdateMarketPricing,
  GetAdminMarketPricingOverview
} from './market-pricings-reports.actions'
import { MarketPricingReportsStateModel } from './market-pricings-reports.model'
import { isEmpty } from 'lodash'

@State<MarketPricingReportsStateModel>({
  name: 'marketPricingReports'
})
@Injectable()
export class MarketPricingReportsState {
  constructor(private reportsService: ReportsService) {}

  @Selector()
  static marketPricing(state: MarketPricingReportsStateModel) {
    return state.marketPricing && !isEmpty(state.marketPricing) ? state.marketPricing : undefined
  }

  @Selector()
  static marketPricingChanged(state: MarketPricingReportsStateModel) {
    return state.marketPricingChanged
  }

  @Selector()
  static thresholds(state: MarketPricingReportsStateModel) {
    return state.thresholds
  }

  @Selector()
  static allMarketPricingsResponse(state: MarketPricingReportsStateModel) {
    return state.allMarketPricingsResponse
  }

  @Selector()
  static adminMarketPricingsOverview(state: MarketPricingReportsStateModel) {
    return state.adminMarketPricingsOverview
  }

  @Action(GetMarketPricing)
  getMarketPricing(ctx: StateContext<MarketPricingReportsStateModel>, { payload }: GetMarketPricing) {
    return this.reportsService.getMarketPricing(payload).pipe(
      tap((res) => {
        ctx.patchState({ marketPricing: res })
      })
    )
  }

  @Action(UpdateMarketPricing)
  updateMarketPricing(
    ctx: StateContext<MarketPricingReportsStateModel>,
    { payload, shopId }: UpdateMarketPricing
  ) {
    return this.reportsService.updateMarketPricing(payload, shopId)
  }

  @Action(GetAdminMarketPricing)
  getAdminMarketPricing(
    ctx: StateContext<MarketPricingReportsStateModel>,
    { info }: GetAdminMarketPricing
  ) {
    return this.reportsService.getAdminMarketPricing(info).pipe(
      tap((res) => {
        ctx.patchState({
          allMarketPricingsResponse: res
        })
      })
    )
  }

  @Action(GetAdminMarketPricingOverview)
  getAdminMarketPricingOverview(
    ctx: StateContext<MarketPricingReportsStateModel>,
    { payload }: GetAdminMarketPricingOverview
  ) {
    return this.reportsService.getAdminMarketPricingOverview(payload).pipe(
      tap((res) => {
        ctx.patchState({
          adminMarketPricingsOverview: res
        })
      })
    )
  }

  @Action(AdminUpdateMarketPricing)
  adminUpdateMarketPricing(
    ctx: StateContext<MarketPricingReportsStateModel>,
    { payload, shopId }: AdminUpdateMarketPricing
  ) {
    return this.reportsService.adminUpdateMarketPricing(payload, shopId)
  }

  @Action(GetMarketPricingThresholds)
  getMarketPricingThresholds(ctx: StateContext<MarketPricingReportsStateModel>) {
    return this.reportsService.getMarketPricingThresholds().pipe(
      tap((res) => {
        ctx.patchState({ thresholds: res })
      })
    )
  }

  @Action(MarketPricingStatusChanged)
  marketPricingStatusChanged(
    ctx: StateContext<MarketPricingReportsStateModel>,
    { payload }: MarketPricingStatusChanged
  ) {
    ctx.patchState({ marketPricingChanged: payload })
  }

  @Action(ResetMarketPricing)
  resetMarketPricing(ctx: StateContext<MarketPricingReportsStateModel>) {
    ctx.patchState({ marketPricing: undefined })
  }
}
